"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailVerificationForm = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var react_i18next_1 = require("react-i18next");
var globalSlice_1 = require("../../../features/global/globalSlice");
var registerSlice_1 = require("../../../features/register/registerSlice");
var auth = __importStar(require("../../../helpers/auth"));
var Routes_1 = require("../../../constants/Routes");
var Copyright_1 = __importDefault(require("../../../components/Copyright"));
var AppSlogan_1 = __importDefault(require("../AppSlogan"));
var Button_1 = __importDefault(require("../../../components/Button"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var EmailVerificationForm = function () {
    var dispatch = react_redux_1.useDispatch();
    var registrationLoading = react_redux_1.useSelector(registerSlice_1.selectRegistrationLoading);
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_1.useHistory();
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(registerSlice_1.resendEmail())];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('RESEND_EMAIL_SUCCESSFULLY'),
                        appearance: 'success',
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    message = e_1.response.status == 503
                        ? t('EMAIL_ALREADY_SUCCESSFULLY_VERIFIED')
                        : t('VERIFY.RESEND_EMAIL_FAILED');
                    dispatch(globalSlice_1.addToastMessage({
                        text: message,
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var registerByNewEmail = function () {
        auth.removeUnverifiedEmail();
        history.push(Routes_1.Routes.Registration.path);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.page },
        react_1.default.createElement(AppSlogan_1.default, { title: t('APP_SLOGAN.TITLE'), text: t('APP_SLOGAN.TEXT') }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.form },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content_body },
                    react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('JUST_ONE_MORE_STEP')),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.sub_title }, t('WE_ALREADY_SEND_VERIFICATION_LINK')),
                    react_1.default.createElement(Button_1.default, { type: "button", variant: "outline", loading: registrationLoading, disabled: registrationLoading, onClick: onSubmit }, t('RESEND_EMAIL')),
                    react_1.default.createElement("a", { className: "register", onClick: registerByNewEmail }, t('VERIFY.REGISTRATION_BY_NEW_EMAIL'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.footer },
                    react_1.default.createElement(Copyright_1.default, null))))));
};
exports.EmailVerificationForm = EmailVerificationForm;
exports.default = exports.EmailVerificationForm;
